import { getWidthMetrics } from './getWidthMetrics';
import type { Chart, RequestedConfig } from './types';
import { VIEW_ONLY_CONFIG_KEYS } from './types';

export const getDataRequestedConfig = (
  config: Chart,
): RequestedConfig<Chart> => {
  const requestedConfig: Record<string, unknown> = { ...config };

  VIEW_ONLY_CONFIG_KEYS.forEach((key) => {
    delete requestedConfig[key];
  });

  // The axis series stay view-only — line style, chart type and value labels
  // must never trigger a refetch — but the width metric is one of the metrics
  // we request, so it has to be part of the cache key or the chart would keep
  // data that lacks the newly picked metric. Omitted when unset, so configs
  // without axis series keep the exact projection they had before.
  const widthMetrics = getWidthMetrics(config);

  if (widthMetrics.length > 0) {
    requestedConfig.widthMetrics = widthMetrics;
  }

  return requestedConfig as RequestedConfig<Chart>;
};
